<template>
    <b-form-group :description="description" :label="label + ':'" :label-for="id" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" :label-cols-sm="labelColsSm" :label-cols-lg="labelColsLg" :class="compact ? 'mb-0' : ''">
        <div :id="id" class="fs-14 grey-color">
            <slot></slot>
        </div>
    </b-form-group>
</template>

<script>
export default {
    name: 'text-row-raw',
    props: {
        label: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        compact: {
            type: Boolean,
            default: false
        },
        labelColsLg: {
            type: Number,
            default: 3
        },
        labelColsSm: {
            type: Number,
            default: 4
        }
    },
    computed: {
        id() {
            return 'text_row_raw_' + this._uid;
        }
    }
};
</script>

<style scoped>
.form-row {
    margin-left: 0;
    margin-right: 0;
}
</style>
